module.exports = __webpack_public_path__ + "img/plane-up-slash.fa51e9b7.svg";